var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.cookieNotice'] = (function () {
    'use strict';

    const CONFIG = {
        CONFIRM_BTN_SELECTOR: "[data-cookienotice='confirm']",
        COOKIE_NAME: "FinancialCenterFirstCU_CookieNotice",
        COOKIE_VALUE: "Confirmed",
        ANIMATION_DURATION: "250ms"
    };

    const initialize = (component) => {
        const confirmButton = component.querySelector(CONFIG.CONFIRM_BTN_SELECTOR);

        // WCAG 2.4.11: the fixed banner covers the bottom of the viewport, so reserve that space when the browser
        // scrolls a focused element into view
        const reserveSpace = () => {
            document.documentElement.style.scrollPaddingBottom = `${component.offsetHeight}px`;
        };
        reserveSpace();
        window.addEventListener("resize", reserveSpace);

        if (confirmButton) {
            confirmButton.addEventListener("click", () => {
                App.Cookies.setItem(CONFIG.COOKIE_NAME, CONFIG.COOKIE_VALUE, Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                window.removeEventListener("resize", reserveSpace);
                document.documentElement.style.scrollPaddingBottom = "";
                moveFocusPast(component);
                animate(component);
            });
        }
    };

    // WCAG 2.4.3: the banner is removed, so send focus to the next focusable element after it instead of <body>
    const moveFocusPast = (component) => {
        if (!component.contains(document.activeElement)) return;

        const focusable = [...document.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter(element => !component.contains(element) && element.offsetParent !== null);
        const next = focusable.find(element => component.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING);

        (next || document.getElementById("page-content"))?.focus();
    };

    const animate = (component) => {
        component.addEventListener("transitionend", (e) => {
            if (e.propertyName === "transform") {
                component.remove();
            }
        });
        const animationDistance = component.offsetHeight;
        component.style.transition = `transform ${CONFIG.ANIMATION_DURATION} ease-in-out`;
        component.style.transform = `translateY(${animationDistance}px)`;
    };

    return {
        initialize
    };

})();
